<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    benefitTitle?: string
    benefits?: {
      title?: string
      description?: string
      icon?: string
    }[]
    withCta?: boolean
  }>(),
  {
    benefitTitle: `Kenapa Harus kirim paket lewat <span class="text-primary">KiriminAja</span>`,
    benefits: () => [
      {
        title: 'Efisien Dan Efektif',
        description:
          'Paket bisa dijemput langsung atau antar ke agen. Pilihan layanannya dari — instan, same-day, express, sampai kargo.',
        icon: 'material-symbols:bolt-outline-rounded'
      },
      {
        title: 'COD Tanpa Marketplace',
        description:
          'Banyak pilihan ekspedisi buat kirim paket COD tanpa lewat marketplace. Dana COD langsung cair real-time, gampang banget!',
        icon: 'material-symbols:package-2-outline'
      },
      {
        title: 'Retur Rendah',
        description:
          'Dengan Return Management System yang sudah terintegrasi, jadi lebih mudah kelola retur dan ngurangin risiko paket gagal kirim.',
        icon: 'material-symbols:article-shortcut-outline'
      },
      {
        title: 'Support 24 Jam',
        description:
          'Tim kami selalu siap bantu kapan aja kalau ada kendala atau masalah dalam proses pengiriman, biar semuanya tetap lancar.',
        icon: 'material-symbols:headset-mic-outline'
      },
      {
        title: 'Integrasi API & Plugin',
        description:
          'Jadi makin gampang ke toko online-mu lewat API, plugin WooCommerce, sampai Shopify — semua tinggal pakai!',
        icon: 'material-symbols:code-blocks-outline'
      },
      {
        title: 'Dashboard Monitoring',
        description:
          'Mulai dari pengelolaan paket, pelacakan real-time, data pelanggan lengkap, sampai laporan keuangan yang detail — semua bisa dalam satu tempat.',
        icon: 'material-symbols:dashboard-customize-outline-rounded'
      }
    ],
    withCta: false
  }
)
</script>

<template>
  <section class="bg-surface-container-low py-10">
    <UiContainer class="py-5 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
        v-html="props.benefitTitle"
      ></h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in props.benefits"
          :key="index"
          :icon="benefit.icon"
          icon-size="28px"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase v-if="withCta" />
    </UiContainer>
  </section>
</template>
